import chopLogo from "@/assets/chop_logo-2.svg";
import useAuthService from "@/services/auth.service";

const Unauthorized = () => {
  const { logout } = useAuthService();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-center px-6">
      <img
        src={chopLogo}
        alt="Children's Hospital of Philadelphia"
        className="h-16 w-auto mb-8"
      />
      <h1 className="text-2xl font-semibold text-gray-800 mb-3">Access Denied</h1>
      <p className="text-gray-600 text-sm max-w-md mb-8 leading-relaxed">
        You don't have permission to access this application. Please contact your
        administrator to request access.
      </p>
      <button
        onClick={() => logout()}
        className="px-6 py-2 rounded-md bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors duration-200"
      >
        Sign out
      </button>
    </div>
  );
};

export default Unauthorized;
